import { createAction, props } from '@ngrx/store';

export const retrieve = createAction('[Invite] Retrieve');
export const retrieveSuccess = createAction('[Invite] Retrieve Success', props<{ invites: any[], inviteMember?: any }>());
export const retrieveFailure = createAction('[Invite] Retrieve Failure', props<{ error: string }>());
export const create = createAction('[Invite] Create');
